import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/spotpris/se2")({
  head: () => seoHead("/spotpris/se2"),
  beforeLoad: () => permanentRedirect("/spotpris/elomrade-se2"),
});
